import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api'
import type { WindowWixCodeSdkSiteConfig } from '../types'

const WIX_CODE_APP_DEF_ID = '675bbcef-18d8-41f5-800e-131ec9e08762'

const windowWixCodeSdkSiteConfig: SiteConfigFn<WindowWixCodeSdkSiteConfig> = ({ api, funcLib }) => {
	const hasPlatform = api.features.isActive('platform')

	if (!hasPlatform) {
		return {
			shouldLoadSiteFeature: false,
			shouldLoadSiteConfig: false,
			siteConfig: null,
		}
	}

	const locale = api.rendererModel.getSitePropertiesInfo()?.locale as string

	const siteMetaData = api.rendererModel.getSiteMetaData()
	const isResponsive = siteMetaData?.isResponsive || false
	const isAdaptiveMobileOn = siteMetaData?.adaptiveMobileOn || false
	const isMobileFriendly = isResponsive || isAdaptiveMobileOn

	const formFactor = api.env.getFormFactor()
	const formFactorCapitalized = funcLib.capitalize(formFactor) as WindowWixCodeSdkSiteConfig['formFactor']

	const routersConfig = api.rendererModel.getRouters()?.configMap || {}
	const pageIdToRouterAppDefinitionId: Record<string, string> = {}

	for (const router of Object.values(routersConfig)) {
		if (!router.appDefinitionId || !router.pages) {
			continue
		}

		for (const pageId of Object.values(router.pages)) {
			const appDefId = router.appDefinitionId === 'wix-code' ? WIX_CODE_APP_DEF_ID : router.appDefinitionId
			pageIdToRouterAppDefinitionId[pageId] = appDefId
		}
	}

	const siteConfig: WindowWixCodeSdkSiteConfig = {
		locale,
		isMobileFriendly,
		formFactor: formFactorCapitalized,
		pageIdToRouterAppDefinitionId,
	}

	return {
		shouldLoadSiteFeature: true,
		shouldLoadSiteConfig: true,
		siteConfig,
	}
}

const name = 'windowWixCodeSdk'

export const config = { site: windowWixCodeSdkSiteConfig, name }
